// extracted by mini-css-extract-plugin
export default {"products":"styles_products__++b9V"};